import { useAsyncData } from "#imports";

export type IconData = {
  svg: string;
  viewBox: number[];
};

function cacheIcon ( id: string, icon: IconData ) {
  if ( !import.meta.client ) {
    return;
  }

  const cacheKey = `a_icon_${id}`;
  localStorage.setItem( cacheKey, JSON.stringify( icon ) );
}

function getCachedIcon ( id: string ): IconData | null {
  let result: IconData | null = null;

  if ( import.meta.client ) {
    const cacheKey = `a_icon_${id}`;
    const rawValue = localStorage.getItem( cacheKey );
    if ( rawValue ) {
      result = JSON.parse( rawValue ) as IconData;
    }
  }

  return result;
}

export function useIconResource () {
  const batcherStore = useBatcherStore();

  async function getIcon ( id: string ) {
    return useAsyncData<IconData>( `a-i-${id}`, async () => {
      const cachedIcon = getCachedIcon( id );
      if ( cachedIcon ) {
        return cachedIcon;
      }

      const iconEndpoint = "/assets/icons";
      const icon = await batcherStore.$fetch<IconData>( iconEndpoint, id );

      if ( icon ) {
        cacheIcon( id, icon );
      }

      return icon;
    } );
  }

  return {
    getIcon,
  };
}

export function $iconResource () {
  const batcherStore = useBatcherStore();

  async function getIcon ( id: string ) {
    const cachedIcon = getCachedIcon( id );
    if ( cachedIcon ) {
      return cachedIcon;
    }

    const iconEndpoint = "/assets/icons";
    const icon = await batcherStore.$fetch<IconData>( iconEndpoint, id );

    if ( icon ) {
      cacheIcon( id, icon );
    }

    return icon;
  }

  return {
    getIcon,
  };
}
